import { parsePhoneNumberFromString, AsYouType } from 'libphonenumber-js/mobile';
import { openBlock, createElementBlock, normalizeClass, normalizeStyle, Fragment, renderList, createElementVNode, toDisplayString, resolveComponent, createVNode, createBlock, createCommentVNode, withDirectives, vModelText } from 'vue';

var script$2 = {
  name: 'CountrySelectorDropdown',
  props: {
    active: {
      type: Boolean,
      required: true
    },
    countries: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    type: {
      type: String,
      required: true,
      validator: function validator(type) {
        return ['line', 'box'].indexOf(type) !== -1;
      }
    }
  },
  computed: {
    styles: function styles() {
      return {
        box: {
          width: '250px'
        },
        line: {
          width: 'calc(250px - 2px)'
        }
      };
    }
  }
};

var _hoisted_1$2 = ["onClick"];
var _hoisted_2$2 = ["src"];
var _hoisted_3$1 = {
  class: "country-name"
};
var _hoisted_4$1 = {
  class: "country-indicator"
};
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["country-selector-dropdown", {
      'active': $props.active,
      'variant-line': $props.type === 'line',
      'variant-box': $props.type === 'box'
    }]),
    style: normalizeStyle({
      width: $options.styles[$props.type].width
    })
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.countries, function (country, i) {
    return openBlock(), createElementBlock("div", {
      key: i,
      class: "item",
      onClick: function onClick($event) {
        return _ctx.$emit('select-country', country);
      }
    }, [createElementVNode("img", {
      class: "country-flag",
      src: country.imgSrc
    }, null, 8, _hoisted_2$2), createElementVNode("p", _hoisted_3$1, toDisplayString(country.name), 1), createElementVNode("p", _hoisted_4$1, toDisplayString(country.indicator), 1)], 8, _hoisted_1$2);
  }), 128))], 6);
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2 = ".country-selector-dropdown[data-v-69c44da2] {\n  position: absolute;\n  -webkit-transform: translateY(10px);\n          transform: translateY(10px);\n  opacity: 0;\n  left: 0;\n  top: 38px;\n  height: 175px;\n  max-height: 175px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  border: 1px solid #C6C6C6;\n  background-color: #fff;\n  -webkit-transition: all 0.25s ease-in-out;\n  transition: all 0.25s ease-in-out;\n  pointer-events: none;\n}\n.country-selector-dropdown.variant-box[data-v-69c44da2] {\n  border-radius: 3px;\n}\n.country-selector-dropdown.active[data-v-69c44da2] {\n  -webkit-transform: translateY(6px);\n          transform: translateY(6px);\n  opacity: 1;\n  pointer-events: auto;\n}\n.country-selector-dropdown .item[data-v-69c44da2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 30px;\n  padding: 0 8px;\n  background-color: #fff;\n  cursor: pointer;\n}\n.country-selector-dropdown .item[data-v-69c44da2]:hover {\n  background-color: rgba(0, 168, 184, 0.15);\n}\n.country-selector-dropdown .item .country-flag[data-v-69c44da2] {\n  display: block;\n  height: 20px;\n  width: auto;\n  margin: 0 12px 0 0;\n}\n.country-selector-dropdown .item .country-name[data-v-69c44da2] {\n  display: inline-block;\n  margin: 0 8px 0 0;\n  color: #000000;\n}\n.country-selector-dropdown .item .country-indicator[data-v-69c44da2] {\n  display: inline-block;\n  margin: 0;\n  color: #8D8D8D;\n}";
styleInject(css_248z$2);

script$2.render = render$2;
script$2.__scopeId = "data-v-69c44da2";

var script$1 = {
  name: 'CountrySelector',
  components: {
    CountrySelectorDropdown: script$2
  },
  props: {
    countries: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // eslint-disable-next-line vue/require-default-prop
    currentIndicator: {
      type: String
    },
    dropdownActive: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator: function validator(type) {
        return ['line', 'box'].indexOf(type) !== -1;
      }
    },
    unknownFlagSrc: {
      type: String,
      required: true
    }
  },
  computed: {
    /* eslint-disable */
    flagImageSrc: function flagImageSrc() {
      var _this = this;

      if (this.currentIndicator) {
        var country = this.countries.find(function (country) {
          return country.isoCode.toLowerCase() === _this.currentIndicator.toLowerCase();
        });

        if (country) {
          return country.imgSrc;
        }
      }

      return this.unknownFlagSrc;
    }
    /* eslint-enable */

  }
};

var _hoisted_1$1 = {
  class: "country-selector"
};
var _hoisted_2$1 = ["src"];
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_country_selector_dropdown = resolveComponent("country-selector-dropdown");

  return openBlock(), createElementBlock("div", _hoisted_1$1, [createElementVNode("div", {
    class: "selected-indicator",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$emit('dropdown-update', !$props.dropdownActive);
    })
  }, [createElementVNode("img", {
    class: "country-flag",
    src: $options.flagImageSrc
  }, null, 8, _hoisted_2$1), createElementVNode("div", {
    class: normalizeClass(["caret", {
      'active': $props.dropdownActive
    }])
  }, null, 2)]), createVNode(_component_country_selector_dropdown, {
    active: $props.dropdownActive,
    countries: $props.countries,
    type: $props.type,
    onSelectCountry: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.$emit('select-country', $event);
    })
  }, null, 8, ["active", "countries", "type"])]);
}

var css_248z$1 = ".country-selector[data-v-fe83d656] {\n  position: relative;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  height: 100%;\n  padding: 0 6px;\n  border-radius: 3px;\n}\n.country-selector .selected-indicator[data-v-fe83d656] {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  cursor: pointer;\n}\n.country-selector .selected-indicator .country-flag[data-v-fe83d656] {\n  display: inline-block;\n  width: 30px;\n  height: 20px;\n  margin: 0 6px 0 0;\n}\n.country-selector .selected-indicator .caret[data-v-fe83d656] {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-top: 4px;\n  border: 3px solid transparent;\n  border-top-color: #707070;\n  -webkit-transform: rotate(0deg);\n          transform: rotate(0deg);\n  -webkit-transform-origin: 3px 1px;\n          transform-origin: 3px 1px;\n  -webkit-transition: 0.25s ease-in-out;\n  transition: 0.25s ease-in-out;\n}\n.country-selector .selected-indicator .caret.active[data-v-fe83d656] {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}";
styleInject(css_248z$1);

script$1.render = render$1;
script$1.__scopeId = "data-v-fe83d656";

var script = {
  name: 'NPhone',
  components: {
    CountrySelector: script$1
  },
  props: {
    allowedNumberTypes: {
      type: Array,
      default: function _default() {
        return ['MOBILE', 'PERSONAL_NUMBER', 'FIXED_LINE'];
      },
      validator: function validator(numberTypes) {
        var validTypes = ['PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL', 'FIXED_LINE_OR_MOBILE', 'FIXED_LINE', 'MOBILE'];
        var invalidNumberType = numberTypes.find(function (numberType) {
          return !validTypes.includes(numberType);
        });

        if (invalidNumberType) {
          console.error("Invalid list of allowed number types for prop \"allowedNumberTypes\" to n-phone component. Please verify this specific number-type: ".concat(JSON.stringify(invalidNumberType)));
        }

        return !invalidNumberType;
      }
    },
    backgroundColor: {
      type: String,
      default: '#00A6B6',
      required: false
    },
    backgroundColorOpaque: {
      type: String,
      default: 'rgba(0, 166, 182, 0.15)',
      required: false
    },
    borderColor: {
      type: String,
      default: '#707070',
      required: false
    },
    countries: {
      type: Array,
      default: function _default() {
        return [];
      },
      validator: function validator(countries) {
        if (countries && Array.isArray(countries)) {
          var invalidCountry = countries.find(function (country) {
            return !country.indicator || !country.isoCode || !country.name || !country.imgSrc;
          });

          if (invalidCountry) {
            console.error("Invalid list of countries for prop \"countries\" to n-phone component. Please verify this specific country: ".concat(JSON.stringify(invalidCountry)));
          }

          return !invalidCountry;
        }

        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    dynamicallyChangeIndicator: {
      type: Boolean,
      required: false
    },
    placeholder: {
      type: String,
      default: '',
      required: false
    },
    primaryColor: {
      type: String,
      default: '#00A6B6',
      required: false
    },
    showIcon: {
      type: Boolean,
      default: true,
      required: false
    },
    showIndicatorSelector: {
      type: Boolean,
      default: true,
      required: false
    },
    type: {
      type: String,
      required: true,
      validator: function validator(type) {
        return ['line', 'box'].indexOf(type) !== -1;
      }
    },
    unknownFlagSrc: {
      type: String,
      required: true
    },
    autocomplete: {
      type: String,
      default: 'tel'
    }
  },
  data: function data() {
    return {
      hasFocus: false,
      dropdownActive: false,
      touched: false,
      dirty: false,
      currentIndicator: null,
      number: ''
    };
  },
  computed: {
    currentCountry: function currentCountry() {
      var _this = this;

      return this.countries.find(function (country) {
        return country.isoCode === _this.currentIndicator;
      });
    },
    isValidNumber: function isValidNumber() {
      var cleanedPhoneNumber = this.number.split(' ').join('');
      var phoneNumber = parsePhoneNumberFromString(cleanedPhoneNumber, this.currentIndicator || undefined);
      var phoneNumberType = phoneNumber && phoneNumber.getType();
      return phoneNumber && phoneNumber.isValid && this.allowedNumberTypes.includes(phoneNumberType);
    },
    isNumberEmpty: function isNumberEmpty() {
      return this.number.length <= 0;
    },
    styles: function styles() {
      return {
        box: {
          containerBoxShadow: this.hasFocus || this.dropdownActive ? "0px 0px 0px 1px ".concat(this.primaryColor) : "0 0 0 0 ".concat(this.primaryColor)
        },
        line: {
          containerBorderColor: this.borderColor,
          containerBackgroundColor: this.hasFocus || this.dropdownActive ? this.backgroundColorOpaque : this.backgroundColor
        }
      };
    }
  },
  watch: {
    number: function number(value) {
      var formattedNumber = new AsYouType(this.currentIndicator || 'FR').input(value); // This condition avoid double emits because of re-assigning the `number`
      // variable with the formatted number.

      if (this.number !== formattedNumber) {
        this.number = formattedNumber;
      } else {
        var parsedNumber = parsePhoneNumberFromString(this.number);

        if (this.dynamicallyChangeIndicator && parsedNumber && parsedNumber.country !== this.currentIndicator) {
          this.currentIndicator = parsedNumber.country;
        }

        this.$emit('change', {
          parsedNumber: parsedNumber,
          country: this.currentCountry,
          valid: this.isValidNumber,
          inputNumber: value
        });
      }
    }
  },
  created: function created() {
    if (this.countries && this.countries[0] && this.countries[0].isoCode) {
      this.currentIndicator = this.countries[0].isoCode;
    }
  },
  mounted: function mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    onDropdownUpdate: function onDropdownUpdate(value) {
      if (!this.disabled) {
        this.dropdownActive = value;
      }
    },
    onSelectCountry: function onSelectCountry(country) {
      this.number = country.indicator;
      this.currentIndicator = country.isoCode;
      this.dropdownActive = false;
      this.$refs['tel-input'].focus();
    },
    handleClickOutside: function handleClickOutside(event) {
      var isClickInsideNPhone = this.$el.contains(event.target);

      if (!isClickInsideNPhone) {
        this.dropdownActive = false;
      }
    }
  }
};

var _imports_0 = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\"><defs><style>.a{fill:#ff3b30;}.b{clip-path:url(#a);}</style><clipPath id=\"a\"><path class=\"a\" d=\"M10.537,11.749,6,7.212,1.463,11.749A.857.857,0,0,1,.251,10.537L4.788,6,.251,1.463A.857.857,0,0,1,1.463.251L6,4.788,10.537.251a.857.857,0,0,1,1.212,1.212L7.212,6l4.537,4.537a.857.857,0,0,1-1.212,1.212Z\"/></clipPath></defs><path class=\"a\" d=\"M10.537,11.749,6,7.212,1.463,11.749A.857.857,0,0,1,.251,10.537L4.788,6,.251,1.463A.857.857,0,0,1,1.463.251L6,4.788,10.537.251a.857.857,0,0,1,1.212,1.212L7.212,6l4.537,4.537a.857.857,0,0,1-1.212,1.212Z\"/></svg>";

var _imports_1 = "<svg id=\"Layer_1\" enable-background=\"new 0 0 512.021 512.021\" height=\"512\" viewBox=\"0 0 512.021 512.021\" width=\"512\" xmlns=\"http://www.w3.org/2000/svg\"><g><path d=\"m367.988 512.021c-16.528 0-32.916-2.922-48.941-8.744-70.598-25.646-136.128-67.416-189.508-120.795s-95.15-118.91-120.795-189.508c-8.241-22.688-10.673-46.108-7.226-69.612 3.229-22.016 11.757-43.389 24.663-61.809 12.963-18.501 30.245-33.889 49.977-44.5 21.042-11.315 44.009-17.053 68.265-17.053 7.544 0 14.064 5.271 15.645 12.647l25.114 117.199c1.137 5.307-.494 10.829-4.331 14.667l-42.913 42.912c40.482 80.486 106.17 146.174 186.656 186.656l42.912-42.913c3.838-3.837 9.361-5.466 14.667-4.331l117.199 25.114c7.377 1.581 12.647 8.101 12.647 15.645 0 24.256-5.738 47.224-17.054 68.266-10.611 19.732-25.999 37.014-44.5 49.977-18.419 12.906-39.792 21.434-61.809 24.663-6.899 1.013-13.797 1.518-20.668 1.519zm-236.349-479.321c-31.995 3.532-60.393 20.302-79.251 47.217-21.206 30.265-26.151 67.49-13.567 102.132 49.304 135.726 155.425 241.847 291.151 291.151 34.641 12.584 71.866 7.64 102.132-13.567 26.915-18.858 43.685-47.256 47.217-79.251l-95.341-20.43-44.816 44.816c-4.769 4.769-12.015 6.036-18.117 3.168-95.19-44.72-172.242-121.772-216.962-216.962-2.867-6.103-1.601-13.349 3.168-18.117l44.816-44.816z\"/></g></svg>";

var _hoisted_1 = {
  class: "container"
};
var _hoisted_2 = ["disabled", "placeholder", "autocomplete"];
var _hoisted_3 = {
  key: 1,
  class: "cross-icon",
  src: _imports_0
};
var _hoisted_4 = {
  key: 2,
  class: "phone-icon",
  src: _imports_1
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_country_selector = resolveComponent("country-selector");

  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["n-phone", {
      'disabled': $props.disabled,
      'focus': _ctx.dropdownActive || _ctx.hasFocus,
      'variant-line': $props.type === 'line',
      'variant-box': $props.type === 'box'
    }]),
    style: normalizeStyle({
      'background-color': $options.styles[$props.type].containerBackgroundColor,
      'border-color': $options.styles[$props.type].containerBorderColor
    })
  }, [createElementVNode("div", _hoisted_1, [$props.showIndicatorSelector ? (openBlock(), createBlock(_component_country_selector, {
    key: 0,
    countries: $props.countries,
    "current-indicator": _ctx.currentIndicator,
    "dropdown-active": _ctx.dropdownActive,
    type: $props.type,
    "unknown-flag-src": $props.unknownFlagSrc,
    onDropdownUpdate: $options.onDropdownUpdate,
    onSelectCountry: $options.onSelectCountry
  }, null, 8, ["countries", "current-indicator", "dropdown-active", "type", "unknown-flag-src", "onDropdownUpdate", "onSelectCountry"])) : createCommentVNode("", true), withDirectives(createElementVNode("input", {
    ref: "tel-input",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.number = $event;
    }),
    class: "tel-input",
    type: "tel",
    disabled: $props.disabled,
    placeholder: $props.placeholder,
    autocomplete: $props.autocomplete,
    onFocus: _cache[1] || (_cache[1] = function ($event) {
      _ctx.hasFocus = true;
      _ctx.touched = true;

      _ctx.$emit('focus');
    }),
    onBlur: _cache[2] || (_cache[2] = function ($event) {
      _ctx.hasFocus = false;

      _ctx.$emit('blur');
    }),
    onKeydown: _cache[3] || (_cache[3] = function ($event) {
      _ctx.dirty = true;
    })
  }, null, 40, _hoisted_2), [[vModelText, _ctx.number]]), _ctx.dirty && !$options.isValidNumber && !$options.isNumberEmpty ? (openBlock(), createElementBlock("img", _hoisted_3)) : createCommentVNode("", true), !(_ctx.dirty && !$options.isValidNumber) && $props.showIcon ? (openBlock(), createElementBlock("img", _hoisted_4)) : createCommentVNode("", true)])], 6);
}

var css_248z = ".n-phone[data-v-a447a170] {\n  position: relative;\n  max-width: 100%;\n}\n.n-phone.disabled .container[data-v-a447a170] {\n  opacity: 0.5;\n}\n.n-phone.variant-box .container[data-v-a447a170] {\n  border-radius: 3px;\n  background-color: #F3F3F3;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n.n-phone .container[data-v-a447a170] {\n  position: relative;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 100%;\n  height: 50px;\n}\n.n-phone .container .tel-input[data-v-a447a170] {\n  width: 100%;\n  height: 30px;\n  border: 0;\n  padding: 0 12px 0 6px;\n  font-size: 1.1em;\n  line-height: inherit;\n  outline: none;\n  background-color: transparent;\n}\n.n-phone .container .tel-input[data-v-a447a170]::-webkit-input-placeholder {\n  color: #8d8d8d;\n}\n.n-phone .container .tel-input[data-v-a447a170]::-moz-placeholder {\n  color: #8d8d8d;\n}\n.n-phone .container .tel-input[data-v-a447a170]:-ms-input-placeholder {\n  color: #8d8d8d;\n}\n.n-phone .container .tel-input[data-v-a447a170]::-ms-input-placeholder {\n  color: #8d8d8d;\n}\n.n-phone .container .tel-input[data-v-a447a170]::placeholder {\n  color: #8d8d8d;\n}\n.n-phone .container .cross-icon[data-v-a447a170] {\n  width: 8px;\n  height: 8px;\n  margin: 0 12px 0 0;\n}\n.n-phone .container .phone-icon[data-v-a447a170] {\n  width: 14px;\n  height: 14px;\n  margin: 0 16px 0 0;\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-a447a170";

export { script as default };
